import * as layoutActions from './actions';

import { ActionType } from 'typesafe-actions';

export * from './actions';
export * from './reducer';
export * from './types';

export type LayoutActions = ActionType<typeof layoutActions>;
